import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="21"
		fill="none"
		viewBox="0 0 16 21"
		{...props}
	>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M14.172 12.122a7.36 7.36 0 1 0-12.343 0l.023.031q.147.223.311.446l4.62 6.495a1.5 1.5 0 0 0 2.445 0l4.612-6.489q.169-.222.323-.445z"
		/>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M8 11.04a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
		/>
	</svg>
);

export { SvgComponent as LocationIcon };
